<template>
  <div>
    <div class="topbar" :style="navbarStyle">
      <a class="navbar-phone" :href="`tel: ${remarks}`" v-if="remarks">{{remarks}}</a>
      <h1 class="topbar-title"><span></span></h1>
      <router-link class="navbar-btn" to="/borrow/city">{{cityName}}</router-link>
    </div>
    <scroller :on-scroll="onScroll" ref="scroller">
      <div class="swiper-container" ref="swiper" style="height:3.06rem">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in banners" :key="index">
            <a :href="item.src" :target="item.target" class="slide-link"
               :style="{backgroundImage:'url(' + (item.url || './banner.jpg') + ')'}">
              <img class="item" :src="item.url">
            </a>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="section-title">
        <h4 class="caption">热门产品</h4>
        <p class="link-group">
          <a v-for="(link, index) in links" @click.prevent="onLinkClick(index)" :key="index">{{link.name}}</a>
        </p>
        <router-link class="icon" to="/borrow/explain"></router-link>
      </div>
      <div class="content-padded">
        <ul class="list-group">
          <li class="list-item" v-for="(item, index) in proList" @click="onItemClick(index)" :key="index">
            <img :src="item.picUrl">
          </li>
        </ul>
        <div class="loadmore" v-show="hasmore" @click="loadmore">
          <a href="javascript:;" class="btn-more">加载更多</a>
        </div>
        <div class="consultants-wrap" v-show="consultantList.length > 0">
          <div class="consultants-swiper">
            <div class="swiper-container" ref="consultantSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(consultant, index) in consultantList" :key="index">
                  <div class="consultant-content">
                    <router-link :to="`consultant/articlelist/${consultant.uid}`">
                      <div class="consultant-head">
                        <img :src="consultant.logoUrl" alt="consultant.name">
                      </div>
                      <div class="consultant-desc">
                        <h3><span class="consultant-name">{{consultant.name}}</span><span
                          class="consultant-job">{{consultant.profession}}</span></h3>
                        <!--<p class="skilled">{{getSkillMap(consultant.skillScore).join(' | ')}}</p>-->
                        <p class="skilled">{{[].concat(consultant.skills).join(' | ')}}</p>
                        <div class="consult-contact">
                          <div class="contact-item"><span class="iconfont">&#xe614;</span><span
                            class="decimal">{{consultant.phone}}</span>
                          </div>
                          <div class="contact-item"><span class="iconfont">&#xe615;</span><span
                            class="decimal">{{consultant.wechat}}</span>
                          </div>
                        </div>
                      </div>
                    </router-link>
                    <div class="consultant-article">
                      <div v-if="consultant.articles[0]"
                           @click.stop="$router.push(`/consultant/article/${consultant.articles[0].author}?id=${consultant.articles[0].id}`)">
                        <span class="tag">{{copyRightMap.get(consultant.articles[0].copyright)}}</span>
                        <p class="title">{{consultant.articles[0].title}}</p>
                        <span class="time text-right">{{consultant.articles[0].auditDate}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <router-link class="consultant-more" to="/consultant" tag="div">
                    <span class="more-zh">查看更多</span>
                    <img class="more-en decimal" src="../../../static/images/MORE.png" alt="" width="47px"/>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <router-link tag="div" class="about" to="/about">
          <img src="/static/images/about.png">
        </router-link>
      </div>
    </scroller>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Spinner from 'components/spinner/spinner'
  import Scroller from 'components/scroller/scroller'
  import Swiper from 'swiper'

  require('swiper/dist/css/swiper.css')

  export default {
    data () {
      return {
        cityName: '',
        remarks: '',
        banners: [],
        links: [],
        proList: [],
        loading: false,
        hasmore: false,
        pageNumber: 1,
        navbarOpacity: 0,
        consultantList: [],
        loanTypeArr: [],
        copyRightMap: new Map(),
        articleArr: [],
        flag: false
      }
    },
    components: {
      Scroller,
      Spinner
    },
    created () {
      this.getDomeFontSize()
    },
    mounted () {
      this.cityName = this.$cache.getCity().name
      this.remarks = this.$cache.getCity().remarks
      this._fetchBanners()
      this._fetchLinks()
      Promise.all([this.getLoanTypeArr(), this._getCopyRightTag(), this.getPushCounselorsByIndex()]).then(() => {
        if (this.consultantList.length > 0) {
          let autoplay = 3000
//          let loop = true
          if (this.consultantList.length === 1) {
            autoplay = 0
//            loop = false
          }
          this.$nextTick(() => {
            this.consultantSwiper && this.consultantSwiper.destroy()
            this.consultantSwiper = new Swiper(this.$refs.consultantSwiper, {
              autoplay: autoplay,
//              loop: loop,
              autoplayDisableOnInteraction: false,
              slidesPerView: 'auto',
              paginationClickable: true,
              spaceBetween: 14
            })
          })
        }
      })
      this._fetchData((list, page) => {
        this.proList = list || []
        this._refresh()
      })
    },
    computed: {
      navbarStyle () {
        return {backgroundColor: `rgba(39,84,130,${this.navbarOpacity})`}
      }
    },
    watch: {
      /* cityName (val) {
       if (val) {
       this._fetchLinks()
       this._fetchData((list, page) => {
       this.proList = list || []
       this._refresh()
       })
       }
       }, */
      banners (list) {
        if (list && list.length) {
          this.$nextTick(() => {
            this.swiper && this.swiper.destroy()
            this.swiper = new Swiper(this.$refs.swiper, {
              pagination: '.swiper-pagination',
              autoplay: 5e3,
              loop: true,
              autoplayDisableOnInteraction: false
            })
          })
        }
      }
    },
    methods: {
      _fetchBanners () {
        let vm = this
        this.$ajax({
          url: '/getBanners.jhtml',
          done (list) {
            vm.banners = list.map((item) => {
              let o = {
                url: item.url,
                src: 'javascript:;'
              }
              if (item.type > 0) {
                o.src = item.src
              }
              if (item.type - 0 === 2) {
                o.target = '_blank'
              }
              return o
            })
            vm._refresh()
          }
        })
      },
      _fetchLinks () {
        let vm = this
        this.$ajax({
          url: '/getProductByCity.jhtml',
          params: {
            cityNo: vm.$cache.getCity().code,
            isPage: 'y',
            pageSize: 3,
            pageNumber: 1
          },
          done (list) {
            vm.links = list
          }
        })
      },
      _fetchData (fn) {
        let vm = this
        this.loading = true
        this.$ajax({
          url: '/getSceneByCity.jhtml',
          params: {
            isPage: 'y',
            pageNumber: vm.pageNumber,
            pageSize: 4,
            cityNo: vm.$cache.getCity().code
          },
          done (list, page) {
            vm.pageNumber = page.pageNumber
            vm.hasmore = page.count > 0 && page.pageNumber * page.pageSize < page.count
            fn && fn(list, page)
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always () {
            vm.loading = false
          }
        })
      },
      _refresh () {
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            }, 500)
          }
        })
      },
      loadmore () {
        if (this.hasmore) {
          this.pageNumber++
          this._fetchData((list, page) => {
            let proList = this.proList
            proList = proList.concat(list)
            this.proList = proList
            this._refresh()
          })
        }
      },
      onLinkClick (index) {
        let item = this.links[index]
        this.$router.push(`/borrow/detail/${item.id}`)
      },
      onItemClick (index) {
        let item = this.proList[index]
        this.$router.push({
          path: '/borrow/explain',
          query: {
            id: item.id
          }
        })
      },
      onScroll (left, top, zoom) {
        this.navbarOpacity = Math.min(Math.max(top / this.swiper.height, 0), 0.98)
      },
      getLoanTypeArr () {
        let vm = this
        return this.$ajax({
          url: '/getLoanTypeMap.jhtml',
          params: {
            cityNo: vm.$cache.getCity().code
          },
          done (result) {
            vm.loanTypeArr = [].concat(result)
          }
        })
      },
      /* getSkillMap (skillScore) {
        let skill = []
        this.loanTypeArr.forEach((loanType) => {
          if ((skillScore & loanType.code) === loanType.code) {
            skill.push(loanType.name)
          }
        })
        return skill
      }, */
      _getCopyRightTag () {
        let vm = this
        return this.$ajax({
          url: '/getLookupCdeList.jhtml',
          params: {
            typeCode: 20008005
          },
          done (result) {
            result.forEach((item) => {
              vm.copyRightMap.set(item.cdeCode, item.cdeName)
            })
            vm.copyRightMap = Object.assign(new Map(), vm.copyRightMap)
          }
        })
      },
      getPushCounselorsByIndex () {
        let vm = this
        return this.$ajax({
          url: '/getPushCounselorsByIndex.jhtml',
          params: {
            cityNo: vm.$cache.getCity().code
          },
          done (result) {
            vm.consultantList = [].concat(vm.$shuffle(result))
            vm._refresh()
          }
        })
      },
      getDomeFontSize () {
        let docEl = document.documentElement
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        if (clientWidth >= 750) {
          docEl.style.fontSize = '100px'
        } else {
          docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
        }
      }
//      getArticleByCounselor () {
//        let map = new Map()
//        for (let i = this.articleArr.length - 1; i >= 0; i--) {
//          let article = this.articleArr[i]
//          map.set(article.author, article)
//        }
//        this.consultantList = this.consultantList.map(consultant => {
//          consultant = Object.assign({}, consultant, { article: map.get(consultant.uid) })
//          return consultant
//        })
//      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  ul, li
    margin 0
    padding 0
    list-style-type none

  .topbar
    position absolute
    top 0
    left 0
    width 100%
    height px2rem(88px)
    z-index 100
    padding 0 px2rem(20px)
    background-repeat no-repeat
    background-position top left
    background-size 100% auto

    .topbar-title
      position absolute
      left 40px
      right 40px
      height 100%
      font-size 0
      text-align center
      letter-spacing px2rem(4px)

      & > span
        display inline-block
        width px2rem(68px)
        height px2rem(68px)
        margin-top px2rem(14px)
        background url(../../../static/images/home-title.png) no-repeat
        background-size 100%
    .navbar-phone
      display inline-block
      position relative
      z-index 20
      float left
      padding px2rem(14px)
      margin-top px2rem(14px)
      font-size px2rem(32px)
      line-height px2rem(32px)
      color #fff
      background-color rgba(0, 0, 0, .25)
      border-radius px2rem(8px)
      vertical-align middle
      &:after
        content ''
        float left
        margin-top px2rem(-4px)
        margin-right px2rem(10px)
        display inline-block
        width px2rem(40px)
        height px2rem(36px)
        transform translate3d(0, 3px, 0)
        -webkit-transform translate3d(0, 3px, 0)
        background url(../../../static/images/icons/home-navbar-phone.png) no-repeat
        background-size 100%
    .navbar-btn
      display inline-block
      position relative
      z-index 20
      float right
      padding px2rem(14px)
      margin-top px2rem(14px)
      font-size px2rem(32px)
      line-height px2rem(32px)
      color #fff
      background-color rgba(0, 0, 0, .25)
      border-radius px2rem(8px)

      &:after
        content ''
        float right
        margin-top px2rem(-4px)
        margin-left px2rem(10px)
        display inline-block
        width px2rem(40px)
        height px2rem(36px)
        background url(../../../static/images/icons/home-navbar-city.png) no-repeat
        background-size 100%

  .slide-link
    display block
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-repeat no-repeat
    background-position center
    background-size cover
    > img, > .item
      display block
      width 100%
      height 100%
      opacity 0

  .section-title

    .caption
      width px2rem(130px)
      white-space nowrap

    .link-group
      display inline-block
      vertical-align bottom
      font-size 0
      width px2rem(500px)
      white-space nowrap
      text-overflow ellipsis
      overflow hidden

      & > a
        display inline-block
        vertical-align middle
        margin-left px2rem(10px)
        line-height px2rem(28px)
        font-size px2rem(28px)
        color #3a74cc
        border-left 1px solid #3a74cc
        padding-left px2rem(10px)
        padding-top px2rem(4px)
        &:last-child
          padding-right px2rem(10px)
          border-right 1px solid #3a74cc

    .icon
      display inline-block
      float right
      margin-top px2rem(-3px)
      width px2rem(40px)
      height px2rem(40px)
      background-image url(../../../static/images/icons/home-section-right.png)
      background-repeat no-repeat
      background-size 100%

  .content-padded
    margin 0 px2rem(20px)

  .list-group
    padding-bottom 1px

    .list-item
      margin-bottom px2rem(20px)
      font-size 0
      border-radius px2rem(20px)
      box-shadow 0 5px 15px #abb9c5

  .loadmore
    margin-bottom px2rem(20px)
    text-align center

    .btn-more
      display inline-block
      font-size px2rem(20px)
      color #3a74cc

      &:after
        content ''
        display block
        margin 5px auto 0
        font-size 0
        width px2rem(36px)
        height px2rem(36px)
        background url(../../../static/images/icons/home-loadmore.png) no-repeat center bottom
        background-size 100%

  .consultants-wrap
    margin-bottom px2rem(24px)
    height px2rem(320px)
    .consultants-swiper
      margin 0
      /*width px2rem(549px)*/
      width px2rem(710px)
      height px2rem(320px)
      overflow hidden
      float left
    .swiper-slide
      width px2rem(549px)
      &:last-child
        width px2rem(127px)
    .consultant-content
      border-radius px2rem(10px)
      overflow hidden
      background url(../../../static/images/bg-consultant.jpg) no-repeat left top / cover
      width px2rem(549px)
      height px2rem(320px)
      padding px2rem(17px) px2rem(22px)
      color #fff
    .consultant-head
      color #fff
      float left
      width px2rem(188px)
      height px2rem(238px)
      overflow hidden
      img
        width px2rem(188px)
        height px2rem(238px)
        display block
    .consultant-desc
      color #fff
      width px2rem(294px)
      float left
      margin-left px2rem(22px)
      h3
        margin 0
        height px2rem(36px)
        span
          display inline-block
      .consultant-name
        padding-top px2rem(4px)
        max-width px2rem(160px)
        font-size px2rem(32px)
        ellipsis()
      .consultant-job
        max-width px2rem(108px)
        margin-left px2rem(10px)
        font-size px2rem(24px)
        padding-top px2rem(4px)
        ellipsis()
      .skilled
        font-size px2rem(24px)
        line-height px2rem(28px)
        height px2rem(110px)
        overflow hidden
        margin 0
        margin-top px2rem(14px)
        margin-bottom px2rem(26px)
      .consult-contact
        padding-top px2rem(12px)
        height px2rem(50px)
        font-size px2rem(24px)
        line-height px2rem(30px)
        border-top 1px solid rgba(255, 255, 255, .3)
        .contact-item
          float left
          width 50%
          ellipsis()
          .iconfont
            margin-right px2rem(10px)
    .consultant-article
      float left
      font-size px2rem(24px)
      width px2rem(502px)
      height px2rem(36px)
      margin-top px2rem(18px)
      padding 0 px2rem(12px)
      line-height px2rem(36px)
      background-color rgba(255, 255, 255, 0.1)
      .tag
        float left
        width px2rem(60px)
      .title
        float left
        width px2rem(260px)
        ellipsis()
        margin 0
        margin-left px2rem(4px)
      .time
        float right
    .consultant-more
      font-size px2rem(26px)
      border-radius px2rem(10px)
      background-color #fff
      width px2rem(127px)
      height px2rem(320px)
      float right
      text-align: center
      color #fff
      background url(../../../static/images/bg-consultant.jpg) no-repeat right top / cover
      .more-zh
        display inline-block
        width px2rem(26px)
        font-weight bold
        padding-top px2rem(100px)
      .more-en
        display block
        margin 0 auto
        margin-top px2rem(50px)
        width px2rem(94px)
        font-size px2rem(24px)

  .about
    font-size 0
    margin-bottom px2rem(15)
    border-radius px2rem(20px)
    box-shadow 0 px2rem(5) px2rem(15) #abb9c5
</style>



// WEBPACK FOOTER //
// borrow.vue?02430ace